import type { ImageBleed } from 'types';
import type { ImageGridModule } from 'types/capi/article';

import { ImageGridCore } from '~/modules/ste/ImageGrid';
import { getBleedClass } from '~/modules/ste/ModuleRow';

type Props = {
  bleed: ImageBleed;
  module: ImageGridModule;
  modulePosition?: number;
  numColumns: number;
};

export default function EmbeddedImageGrid({
  bleed,
  module,
  modulePosition,
  numColumns
}: Props) {
  const bleedClass = getBleedClass(bleed, numColumns);

  const mobileBleedClass =
    bleed !== 'none' && numColumns !== 4 ? 'max-md:-mx-4' : '';

  return (
    <div className={`${mobileBleedClass} ${bleedClass}`}>
      <ImageGridCore
        items={module.items}
        bleed={bleed}
        modulePosition={modulePosition}
      />
    </div>
  );
}
